import { Box } from '@zillow/constellation-10';

import PropertiesConstants from '../../../constants/PropertiesConstants';

import FlexiblePropertyCard from './FlexiblePropertyCard';

import type { AccountViewListingGroupDto } from '@zg-rentals/ts-rental-manager-api-client';

type Props = {
  listingGroups: Array<AccountViewListingGroupDto>;
  isLoading?: boolean;
};

const createSkeletonListing = (index: number): AccountViewListingGroupDto =>
  ({
    groupId: `skeleton-${index}`,
    listingAlias: `skeleton-${index}`,
    name: '',
    photoKey: '',
    address: { street: '', city: '', state: '', zip: '', unit: '' },
  }) as AccountViewListingGroupDto;

export const FlexiblePropertyCardList = ({ listingGroups, isLoading = false }: Props) => {
  const showSkeletons = isLoading && listingGroups.length === 0;

  const items = showSkeletons
    ? Array.from({ length: PropertiesConstants.PROPERTIES_LIMIT_DEFAULT }, (_, index) => createSkeletonListing(index))
    : listingGroups;

  return (
    <Box
      data-testid="FlexiblePropertyCardList"
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: '400',
      }}
    >
      {items.map((listing) => (
        <FlexiblePropertyCard key={listing.groupId} listing={listing} isLoading={showSkeletons} />
      ))}
    </Box>
  );
};
